export const dateColumns = ['createdAt', 'updatedAt', 'registeredAt']
